diy.angular.registerFactory('diyfmsourcecms', [
    '$q',
    '$injector', 
    '$http', 
    '$sce', 
    'diyl10n', 
    'diyfeatures',
    'diyfmmessages',
function(
    $q,
    $injector, 
    $http,
    $sce,
    diyl10n, 
    diyfeatures,
    diyfmmessages
) {
    var 
        source = {},
        itemsProvider = {},
        upsellContents = ''
    ;
    
    var getName = function() {
        return 'cms';
    };
    
    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };
    
    var isAvailable = function() {
        return diyfeatures('cmsImagesAvailable');
    };

    var shouldShowUpsell = function() {
        return diyfeatures('cmsImagesUpgradable');
    };

    var getUpsellContents = function() {
        return upsellContents;
    };

    var getSourceServiceUrl = function () {
        return cc_.properties.cmsUrl + 'rest/images';
    };

    var getLanguage = function () {
        return jimdoData.cmsLanguage.substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch, colorSearch, topicIdSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : null;
            colorSearch = params.hasOwnProperty('colorSearch') ? params.colorSearch : null;
            topicIdSearch = params.hasOwnProperty('topicId') ? params.topicId : null;

            // compose path params //
            pathParams += ';language=' + encodeURIComponent(getLanguage());
            if (textSearch) {
                pathParams += ';searchQuery=' + encodeURIComponent(textSearch);
            }
            if (colorSearch) {
                pathParams += ';searchColor=' + encodeURIComponent(colorSearch);
            }
            if (topicIdSearch) {
                pathParams += ';topic=' + encodeURIComponent(topicIdSearch);
            }

            $http.get(getSourceServiceUrl() + pathParams, {
                headers: {
                    'X-Diy-Range': 'items=' + Math.max(0, offset) + '-' + (Math.max(0, offset + limit - 1))
                }
            }).then(function (response) {
                try {
                    var i, images = response.data.images, length = images.length, convertedImages = [],
                        totalCount, contentRange;

                    for (var i = 0; i < length; i++) {
                        convertedImages.push({
                            id: images[i].imageId,
                            thumb: images[i].links.thumbnail.href,
                            file: images[i].links.original.href,
                            preview: images[i].links.preview.href
                        });
                    }

                    contentRange = response.headers('x-diy-content-range');
                    if (contentRange) {
                        // Content-Range header have a format like "range start-end/total" (i.e. "items 0-99/200")
                        totalCount = parseInt(contentRange.split('/')[1], 10);
                    }

                    defer.resolve({
                        items: convertedImages,
                        totalCount: totalCount
                    });
                } catch (err) {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function () {
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        } else {
            // load the upsell view only when needed //
            $http.get('/app/module/marketing/imagesupsellview').then(function(response) {
                // this will ensure that this string will be appended just as it is, without removing onclick attributes and other tags
                upsellContents = $sce.trustAsHtml(response.data);
            });

            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };
    
    var getItemsProvider = function() {
        return itemsProvider;
    };
    
    var toolbarItems = [];
    if (isAvailable()) {
        toolbarItems = [
            ' ', // spacer
            function() {
                return '<div diyfmcolorsfilter></div>';
            },
            'search'
        ];
    }
    var restrictedToolbarItems = [];
    
    var getToolbarItems = function(subsection) {
        if (subsection.getTypeName() === 'cmsPhotos') {
            return toolbarItems;
        } else {
            return restrictedToolbarItems;
        }
    };
    
    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        shouldShowUpsell: shouldShowUpsell,
        getUpsellContents: getUpsellContents,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems
    });
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsourcecms.js
 ** module id = 949
 ** module chunks = 0
 **/